import { defineMessages } from 'react-intl';
import { HasExistingReturnRabbitAccount, StoreAlreadyRegisteredEnhancedReturns } from '../code-constants';

export const messages = defineMessages({
  [HasExistingReturnRabbitAccount]: {
    description: 'Error when trying to activate a store for enhanced returns that is already linked to ReturnRabbit.',
    defaultMessage:
      "This store is already linked to ReturnRabbit and can't be used for Returns and Exchanges in ShipStation. Please contact support for assistance.",
    id: 'Ib6Y38',
  },
  [StoreAlreadyRegisteredEnhancedReturns]: {
    description: 'Error when trying to activate a store for enhanced returns that is already activated.',
    defaultMessage: 'This store is already connected to a ShipStation account for returns. Please contact support for assistance.',
    id: 'AWn6Oi',
  },
});

export const enhancedReturnsErrorBuilder = ({ code }) => {
  return messages[code];
};
